// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type OrgFeatureView = {
  key: string;
  name: string;
  description: string;
  category: string;
  status: string;
  entitled: boolean;
  state: "on" | "locked" | "off";
  reason: string | null;
  platformManaged: boolean;
  discoveryMode: string | null;
};
export const OrgFeatureViewSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  category: z.string(),
  status: z.string(),
  entitled: z.boolean(),
  state: z.enum(["on", "locked", "off"] as const),
  reason: z.string().nullable(),
  platformManaged: z.boolean(),
  discoveryMode: z.string().nullable(),
}).strict();

export type SetOrgFeatureBody = {
  featureKey: string;
  enabled: boolean;
  roleId?: string | undefined;
};
export const SetOrgFeatureBodySchema = z.object({
  featureKey: z.string().min(1),
  enabled: z.boolean(),
  roleId: z.string().regex(new RegExp("^[0-9a-fA-F]{24}$"), "must be a Mongo ObjectId").optional(),
}).strict();

export type OrgFlagStateView = {
  featureKey: string;
  roleId: string | null;
  enabled: boolean;
  state: "on" | "off";
  plane: "org";
};
export const OrgFlagStateViewSchema = z.object({
  featureKey: z.string(),
  roleId: z.string().nullable(),
  enabled: z.boolean(),
  state: z.enum(["on", "off"] as const),
  plane: z.literal("org"),
}).strict();

export type ListOrgFeaturesResponse = {
  data: Array<OrgFeatureView>;
};

export const ListOrgFeaturesParamsSchema = z.object({
  orgId: z.string().regex(new RegExp("^[0-9a-fA-F]{24}$"), "must be a Mongo ObjectId"),
});

export async function listOrgFeatures(orgId: string): Promise<ListOrgFeaturesResponse> {
  const response = await api.get<ListOrgFeaturesResponse>(`/orgs/${encodeURIComponent(orgId)}/features`);
  return response.data;
}

export type SetOrgFeatureResponse = {
  data: OrgFlagStateView;
};

export const SetOrgFeatureParamsSchema = z.object({
  orgId: z.string().regex(new RegExp("^[0-9a-fA-F]{24}$"), "must be a Mongo ObjectId"),
});

export async function setOrgFeature(orgId: string, body: SetOrgFeatureBody): Promise<SetOrgFeatureResponse> {
  const response = await api.post<SetOrgFeatureResponse>(`/orgs/${encodeURIComponent(orgId)}/flags`, body);
  return response.data;
}

export const orgFeaturesKeys = {
  all: ["orgFeatures"] as const,
  lists: () => [...orgFeaturesKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...orgFeaturesKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...orgFeaturesKeys.all, 'detail'] as const,
  detail: (id: string) => [...orgFeaturesKeys.details(), id] as const,
};
